const { useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('etf-rank');

export default (props) => {
    // ETF榜
    const getEtfRank = async () => {
        const data = {
            market: props.market,
            lang: props.language,
            count: props.count,
            increase_type: props.increaseType || INCREASE_TYPE.CLOSE
        };
        try {
            return await request.get('get-rank-list', data);
        } catch (err) {
            console.error('get-rank-rank_error', err);
        }
    };

    return {
        getEtfRank
    };
};
